/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export enum FlexpaConnectionStatus {
  CONNECTED = 'CONNECTED',
  SYNC_FAILED = 'SYNC_FAILED',
  NEEDS_REAUTH = 'NEEDS_REAUTH',
  REVOKED = 'REVOKED',
  EXPIRED = 'EXPIRED',
  PATIENT_MISMATCH = 'PATIENT_MISMATCH',
}
